module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Sessions/Auth Sandbox")]), _vm._v(" "), _c('div', {
    on: {
      "keydown": _vm.enter_save_update
    }
  }, [_c('h3', [_vm._v("Register new user or update information")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "placeholder": "name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "placeholder": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.school),
      expression: "school"
    }],
    attrs: {
      "placeholder": "school"
    },
    domProps: {
      "value": (_vm.school)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.school = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirm_password),
      expression: "confirm_password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "confirm password"
    },
    domProps: {
      "value": (_vm.confirm_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirm_password = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.save_update
    }
  }, [_vm._v("submit")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.status))])]), _vm._v(" "), (!_vm.authorized) ? _c('div', {
    on: {
      "keydown": _vm.enter_login
    }
  }, [_c('h3', [_vm._v("Log in to view pages")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login_email),
      expression: "login_email"
    }],
    attrs: {
      "placeholder": "email"
    },
    domProps: {
      "value": (_vm.login_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.login_email = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login_password),
      expression: "login_password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.login_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.login_password = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.login
    }
  }, [_vm._v("log in")]), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.login_status))])]) : _vm._e(), _vm._v(" "), (_vm.authorized) ? _c('div', {
    staticClass: "page-content"
  }, [_c('h2', [_vm._v("Logged in as " + _vm._s(_vm.page_content.name))]), _vm._v(" "), _c('p', [_vm._v("Current Page: " + _vm._s(_vm.page_content.current_page))]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.prev_page
    }
  }, [_vm._v("Go to previous page")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.next_page
    }
  }, [_vm._v("Go to next page")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44c9bd12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/templates/auth_sandbox.vue
// module id = 617
// module chunks = 1